// extracted by mini-css-extract-plugin
export default {"main":"Users_main__Qmpup"};